module.exports = __webpack_public_path__ + "static/media/Katherine Wayne Headshot.22f66387.jpeg";